import type {ReactNode} from 'react'
import {useOverviewRouteData} from './data/use-overview-route-data'
import {LabelsPicker} from './LabelsPicker'
import {SidebarSection} from './SidebarSection'

export function LabelsSection({children}: {children: ReactNode}) {
  const {user} = useOverviewRouteData()
  const canManageLabels = user?.canLabel ?? false

  return (
    <SidebarSection title="Labels" header={canManageLabels ? <LabelsPicker /> : undefined}>
      {children}
    </SidebarSection>
  )
}
